export default {"src":"/_next/static/media/QAR.333f3647.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};